import { ACTIONS } from '../constants/order-items';
import { MODE } from '../constants/mode';

const INITIAL_STATE = {
  orderItemsList: { orderItems: [], params: {}, pager: null, error: null, loading: false },
  checkInItemsList: { orderItems: [], params: {}, pager: null, error: null, loading: false },
  activeOrderItem: { orderItem: null, error: null, mode: null },
};

export const orderItems = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.ORDER_ITEM_CREATE_RESET:
    case ACTIONS.ORDER_ITEM_UPDATE_RESET:
    case ACTIONS.ORDER_ITEM_DELETE_RESET:
    case ACTIONS.ORDER_ITEM_FETCH_RESET:
      return {
        ...state,
        activeOrderItem: {
          orderItem: null,
          loading: false,
          error: null,
          mode: null,
        },
      };

    case ACTIONS.ORDER_ITEM_CREATE_START:
      return {
        ...state,
        activeOrderItem: {
          orderItem: action.payload,
          loading: true,
          error: null,
          mode: MODE.CREATE,
        },
      };
    case ACTIONS.ORDER_ITEM_CREATE_FAILURE:
      return {
        ...state,
        activeOrderItem: {
          orderItem: null,
          loading: false,
          error: action.payload,
          mode: MODE.CREATE,
        },
      };
    case ACTIONS.ORDER_ITEM_CREATE_SUCCESS:
      return {
        ...state,
        orderItemsList: {
          ...state.orderItemsList,
          orderItems: state.orderItemsList.orderItems.concat(action.payload),
          error: null,
          loading: false,
        },
        activeOrderItem: {
          orderItem: action.payload,
          loading: false,
          error: null,
          mode: MODE.CREATE,
        },
      };

    case ACTIONS.ORDER_ITEM_UPDATE_START:
      return {
        ...state,
        activeOrderItem: {
          orderItem: action.payload,
          loading: true,
          error: null,
          mode: MODE.UPDATE,
        },
      };
    case ACTIONS.ORDER_ITEM_UPDATE_FAILURE:
      return {
        ...state,
        activeOrderItem: {
          orderItem: null,
          loading: false,
          error: action.payload,
          mode: MODE.UPDATE,
        },
      };
    case ACTIONS.ORDER_ITEM_UPDATE_SUCCESS:
      return {
        ...state,
        orderItemsList: {
          ...state.orderItemsList,
          orderItems: state.orderItemsList.orderItems.map(item => {
            if (item.id === action.payload.id) {
              item = action.payload;
            }
            return item;
          }),
          error: null,
          loading: false,
        },
        activeOrderItem: {
          orderItem: action.payload,
          loading: false,
          error: null,
          mode: MODE.UPDATE,
        },
      };

    case ACTIONS.ORDER_ITEM_DELETE_START:
      return {
        ...state,
        activeOrderItem: {
          orderItem: action.payload,
          loading: true,
          error: null,
          mode: MODE.DELETE,
        },
      };
    case ACTIONS.ORDER_ITEM_DELETE_FAILURE:
      return {
        ...state,
        activeOrderItem: {
          orderItem: null,
          loading: false,
          error: action.payload,
          mode: MODE.DELETE,
        },
      };
    case ACTIONS.ORDER_ITEM_DELETE_SUCCESS:
      return {
        ...state,
        orderItemsList: {
          ...state.orderItemsList,
          orderItems: state.orderItemsList.orderItems.filter(item => item.id !== action.payload.id),
          error: null,
          loading: false,
        },
        activeOrderItem: {
          orderItem: action.payload,
          loading: false,
          error: null,
          mode: MODE.DELETE,
        },
      };

    case ACTIONS.ORDER_ITEM_FETCH_START:
      return {
        ...state,
        activeOrderItem: {
          orderItem: action.payload,
          loading: true,
          error: null,
          mode: MODE.VIEW,
        },
      };
    case ACTIONS.ORDER_ITEM_FETCH_FAILURE:
      return {
        ...state,
        activeOrderItem: {
          orderItem: null,
          loading: false,
          error: action.payload,
          mode: MODE.VIEW,
        },
      };
    case ACTIONS.ORDER_ITEM_FETCH_SUCCESS:
      return {
        ...state,
        activeOrderItem: {
          orderItem: action.payload,
          loading: false,
          error: null,
          mode: MODE.VIEW,
        },
      };

    case ACTIONS.ORDER_ITEMS_FETCH_START:
      return {
        ...state,
        orderItemsList: {
          orderItems: [],
          params: action.payload,
          pager: null,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.ORDER_ITEMS_FETCH_SUCCESS:
      return {
        ...state,
        orderItemsList: {
          ...state.orderItemsList,
          orderItems: action.payload.results,
          pager: action.payload.paginator,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.ORDER_ITEMS_FETCH_FAILURE:
      return {
        ...state,
        orderItemsList: {
          ...state.orderItemsList,
          orderItems: [],
          pager: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.ORDER_ITEMS_FETCH_RESET:
      return {
        ...state,
        orderItemsList: {
          orderItems: [],
          params: null,
          pager: null,
          error: null,
          loading: false,
        },
      };

    case ACTIONS.ORDER_ITEMS_CHECK_IN_FETCH_START:
      return {
        ...state,
        checkInItemsList: {
          orderItems: [],
          params: action.payload,
          pager: null,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.ORDER_ITEMS_CHECK_IN_FETCH_SUCCESS:
      return {
        ...state,
        checkInItemsList: {
          ...state.checkInItemsList,
          orderItems: action.payload.results,
          pager: action.payload.paginator,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.ORDER_ITEMS_CHECK_IN_FETCH_FAILURE:
      return {
        ...state,
        checkInItemsList: {
          ...state.checkInItemsList,
          orderItems: [],
          pager: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.ORDER_ITEMS_CHECK_IN_FETCH_RESET:
      return {
        ...state,
        checkInItemsList: {
          orderItems: [],
          params: null,
          pager: null,
          error: null,
          loading: false,
        },
      };

    default:
      return state;
  }
};
